export default __webpack_public_path__ + "static/media/facebook.88ef84b0.svg";